// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Admin Page Header Styles */
.admin-page-header {
    background-color: #72c79f;
    color: rgb(7, 7, 7);
    padding: 2rem 0;
    text-align: center;
    margin-bottom: 2rem;
  }
  
  .admin-header-content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1rem;
  }
  
  .admin-header-content h1 {
    font-size: 2.2rem;
    margin-bottom: 0.5rem;
  }
  
  .admin-header-content p {
    font-size: 1.1rem;
    opacity: 0.9;
  }
  
  /* Rest of your existing styles */
  .demo-schedule-container {
    max-width: 600px;
    margin: 0 auto 3rem auto;
    padding: 2rem;
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  }
  
  .schedule-form {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }
  
  .form-group {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .form-group label {
    font-size: 1rem;
    color: #4a5568;
    font-weight: 500;
  }
  
  .form-group input[type="date"] {
    padding: 0.75rem;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    font-size: 1rem;
    transition: border-color 0.3s ease;
  }
  
  .form-group input[type="date"]:focus {
    outline: none;
    border-color: #4299e1;
    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.2);
  }
  
  .time-selector-container {
    position: relative;
  }
  
  .time-selector {
    height: 200px;
    overflow-y: auto;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    padding: 0.5rem;
    background: white;
  }
  
  .time-option {
    padding: 0.5rem;
    margin: 0.25rem 0;
    border-radius: 4px;
    cursor: pointer;
    font-family: monospace;
    text-align: center;
    transition: all 0.2s ease;
  }
  
  .time-option:hover {
    background-color: #ebf8ff;
  }
  
  .time-option.selected {
    background-color: #4299e1;
    color: white;
    font-weight: bold;
  }
  
  .submit-btn {
    background-color: #4299e1;
    color: white;
    padding: 0.75rem;
    border: none;
    border-radius: 6px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.3s ease;
    margin-top: 1rem;
    align-items: center;
    align-content: center;
    margin-left: 68px;
  }
  
  .submit-btn:hover {
    background-color: #3182ce;
  }
  
  .confirmation-message {
    margin-top: 2rem;
    padding: 1.5rem;
    background-color: #f0f9ff;
    border-radius: 8px;
    text-align: center;
    color: #2b6cb0;
  }
  
  .selected-date {
    font-size: 1.25rem;
    font-weight: 600;
    margin: 0.5rem 0;
    color: #2c5282;
  }
  
  .selected-time {
    font-size: 1.5rem;
    font-weight: 600;
    margin: 0.5rem 0;
    color: #2b6cb0;
  }
  
  /* Custom scrollbar */
  .time-selector::-webkit-scrollbar {
    width: 8px;
  }
  
  .time-selector::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  
  .time-selector::-webkit-scrollbar-thumb {
    background: #cbd5e0;
    border-radius: 4px;
  }
  
  .time-selector::-webkit-scrollbar-thumb:hover {
    background: #a0aec0;
  }
  
  /* Responsive adjustments */
  @media (max-width: 768px) {
    .admin-page-header {
      padding: 1.5rem 0;
    }
    
    .admin-header-content h1 {
      font-size: 1.8rem;
    }
    
    .demo-schedule-container {
      margin: 0 1rem 2rem 1rem;
      padding: 1.5rem;
    }
    
    .time-selector {
      height: 150px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/MyComponents/ChatBot/Demo-admin.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;IACI,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA,iCAAiC;EACjC;IACE,gBAAgB;IAChB,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,yCAAyC;IACzC,4DAA4D;EAC9D;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,kCAAkC;EACpC;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,6CAA6C;EAC/C;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,sCAAsC;IACtC,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;EAChB;;EAEA,qBAAqB;EACrB;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA,2BAA2B;EAC3B;IACE;MACE,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,wBAAwB;MACxB,eAAe;IACjB;;IAEA;MACE,aAAa;IACf;EACF","sourcesContent":["/* Admin Page Header Styles */\n.admin-page-header {\n    background-color: #72c79f;\n    color: rgb(7, 7, 7);\n    padding: 2rem 0;\n    text-align: center;\n    margin-bottom: 2rem;\n  }\n  \n  .admin-header-content {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 0 1rem;\n  }\n  \n  .admin-header-content h1 {\n    font-size: 2.2rem;\n    margin-bottom: 0.5rem;\n  }\n  \n  .admin-header-content p {\n    font-size: 1.1rem;\n    opacity: 0.9;\n  }\n  \n  /* Rest of your existing styles */\n  .demo-schedule-container {\n    max-width: 600px;\n    margin: 0 auto 3rem auto;\n    padding: 2rem;\n    background: #ffffff;\n    border-radius: 10px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  }\n  \n  .schedule-form {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n  }\n  \n  .form-group {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n  \n  .form-group label {\n    font-size: 1rem;\n    color: #4a5568;\n    font-weight: 500;\n  }\n  \n  .form-group input[type=\"date\"] {\n    padding: 0.75rem;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    font-size: 1rem;\n    transition: border-color 0.3s ease;\n  }\n  \n  .form-group input[type=\"date\"]:focus {\n    outline: none;\n    border-color: #4299e1;\n    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.2);\n  }\n  \n  .time-selector-container {\n    position: relative;\n  }\n  \n  .time-selector {\n    height: 200px;\n    overflow-y: auto;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    padding: 0.5rem;\n    background: white;\n  }\n  \n  .time-option {\n    padding: 0.5rem;\n    margin: 0.25rem 0;\n    border-radius: 4px;\n    cursor: pointer;\n    font-family: monospace;\n    text-align: center;\n    transition: all 0.2s ease;\n  }\n  \n  .time-option:hover {\n    background-color: #ebf8ff;\n  }\n  \n  .time-option.selected {\n    background-color: #4299e1;\n    color: white;\n    font-weight: bold;\n  }\n  \n  .submit-btn {\n    background-color: #4299e1;\n    color: white;\n    padding: 0.75rem;\n    border: none;\n    border-radius: 6px;\n    font-size: 1rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    margin-top: 1rem;\n    align-items: center;\n    align-content: center;\n    margin-left: 68px;\n  }\n  \n  .submit-btn:hover {\n    background-color: #3182ce;\n  }\n  \n  .confirmation-message {\n    margin-top: 2rem;\n    padding: 1.5rem;\n    background-color: #f0f9ff;\n    border-radius: 8px;\n    text-align: center;\n    color: #2b6cb0;\n  }\n  \n  .selected-date {\n    font-size: 1.25rem;\n    font-weight: 600;\n    margin: 0.5rem 0;\n    color: #2c5282;\n  }\n  \n  .selected-time {\n    font-size: 1.5rem;\n    font-weight: 600;\n    margin: 0.5rem 0;\n    color: #2b6cb0;\n  }\n  \n  /* Custom scrollbar */\n  .time-selector::-webkit-scrollbar {\n    width: 8px;\n  }\n  \n  .time-selector::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 4px;\n  }\n  \n  .time-selector::-webkit-scrollbar-thumb {\n    background: #cbd5e0;\n    border-radius: 4px;\n  }\n  \n  .time-selector::-webkit-scrollbar-thumb:hover {\n    background: #a0aec0;\n  }\n  \n  /* Responsive adjustments */\n  @media (max-width: 768px) {\n    .admin-page-header {\n      padding: 1.5rem 0;\n    }\n    \n    .admin-header-content h1 {\n      font-size: 1.8rem;\n    }\n    \n    .demo-schedule-container {\n      margin: 0 1rem 2rem 1rem;\n      padding: 1.5rem;\n    }\n    \n    .time-selector {\n      height: 150px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
